// Shared annotation for the Parts / Documents grids: a row whose part or drawing is also linked to
// one or more assemblies is tinted with the resource color and shows a tooltip listing them. The
// row must carry an `Assemblies` array (enriched by the search hooks).

type AssemblyRef = { AssemblyAssetId: number; AssemblyName: string };

export const rowIsInAssembly = (data: any): boolean =>
	Array.isArray(data?.Assemblies) && data.Assemblies.length > 0;

// Tooltip text listing the assemblies that contain this row's part / drawing. Returns undefined
// when the row is not in any assembly, so no tooltip shows.
export const getAssemblyTooltip = (data: any): string | undefined => {
	const asm: AssemblyRef[] = data?.Assemblies ?? [];
	if (!asm.length) return undefined;
	const names = asm.map((a) => a.AssemblyName).join(", ");
	return `In ${asm.length} assembl${asm.length > 1 ? "ies" : "y"}: ${names}`;
};
